// extracted by mini-css-extract-plugin
module.exports = {"v1m9kdym":"v1m9kdym"};